const SUBJECT_KEYWORD_COLORS: Array<{ keyword: string, color: string }> = [
  { keyword: 'matematica', color: '#F8CBCB' },
  { keyword: 'lenguaje', color: '#C6E0B4' },
  { keyword: 'ciencia', color: '#C9DAF8' },
  { keyword: 'social', color: '#FFE699' },
  { keyword: 'historia', color: '#FFE699' },
];

const FALLBACK_COLORS = [
  '#E4D7F5', '#D9EAD3', '#FCE5CD', '#D0E0E3', '#EAD1DC', '#FFF2CC',
];

const DEFAULT_COLOR = '#EEEEEE';

const ACCENTS: { [char: string]: string } = {
  á: 'a', é: 'e', í: 'i', ó: 'o', ú: 'u', ü: 'u',
};

const normalize = (value: string): string => value
  .toLowerCase()
  .replace(/[áéíóúü]/g, (char) => ACCENTS[char] ?? char);

export const getSubjectColor = (
  subjectName: string | null,
  subjectId: number | null,
): string => {
  if (subjectName) {
    const normalized = normalize(subjectName);
    const match = SUBJECT_KEYWORD_COLORS.find((elem) => normalized.includes(elem.keyword));
    if (match) {
      return match.color;
    }
  }

  if (subjectId !== null && subjectId !== undefined) {
    return FALLBACK_COLORS[Math.abs(subjectId) % FALLBACK_COLORS.length];
  }

  return DEFAULT_COLOR;
};

export default getSubjectColor;
